import { render, staticRenderFns } from "./Line-Item-Projects.vue?vue&type=template&id=fd9324b6"
import script from "./Line-Item-Projects.vue?vue&type=script&lang=js"
export * from "./Line-Item-Projects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports